import React from "react";
import { pastelDark } from "../Pages/Main/constants";
import CoursesMain from "../Pages/Courses/CoursesMain";
import CoursesForm from "../Pages/Courses/CoursesForm";
import ReferencePage from "../Pages/ReferencePage/ReferencePage";
import PhotoPage from "../Pages/PhotoPage/PhotoPage";
import ObchodniPodminkyKurzy from "../Pages/Legal/ObchodniPodminkyKurzy";
import ZasadySoukromiKurzy from "../Pages/Legal/ZasadySoukromiKurzy";
import AboutPage from "../Pages/AboutPage/AboutPage";

const ErrorPage = React.lazy(() => import("../Pages/ErrorPage/ErrorPage"));
const FormPage = React.lazy(() => import("../Pages/Main/FormPage"));
const MainPage = React.lazy(() => import("../Pages/Main/MainPage"));
const ChooseProgram = React.lazy(() => import("../Pages/ChooseProgram"));
const ProgramDetail = React.lazy(() => import("../Pages/ProgramDetail"));
const AdminLogin = React.lazy(() => import("../Pages/AdminLogin"));
const PreviewPage = React.lazy(() => import("../Pages/Admin/PreviewPage"));
const Dokumenty = React.lazy(() => import("../Pages/Dokumenty"));
const ResultPage = React.lazy(() => import("../Pages/Main/ResultPage"));
const Cookies = React.lazy(() => import("../Pages/Cookies"));
const ObchodniPodminky = React.lazy(() => import("../Pages/Legal/ObchodniPodminky"));
const ZasadySoukromi = React.lazy(() => import("../Pages/Legal/ZasadySoukromi"));

const darkNavbar = { navbar: { bgcolor: 'rgba(255, 173, 102, 0.7)', xsText: { textShadow: 'none', color: pastelDark } } };

const baseRoutes = [
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "/",
    element: <MainPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
    handle: darkNavbar,
  },
  {
    path: "/fotky",
    element: <PhotoPage />,
    handle: darkNavbar
  },
  {
    path: "/reference",
    element: <ReferencePage />,
    handle: darkNavbar
  },
  {
    path: "/programy",
    element: <ChooseProgram />,
  },
  {
    path: "/detail",
    element: <ProgramDetail />,
    handle: darkNavbar
  },
  {
    path: "/rezervace",
    element: <FormPage />,
    handle: darkNavbar
  },
  {
    path: "/rezervace/:program",
    element: <FormPage />,
    handle: darkNavbar
  },
  {
    path: "/program/:program",
    element: <ProgramDetail />,
    handle: darkNavbar
  },
  {
    path: "/result/:userId",
    element: <ResultPage />,
    handle: darkNavbar
  },
  {
    path: "/result",
    element: <ResultPage />,
    handle: darkNavbar
  },
  {
    path: "/zasady",
    element: <ZasadySoukromi />,
    handle: darkNavbar
  },
  {
    path: "/podminky",
    element: <ObchodniPodminky />,
    handle: darkNavbar
  },
  // KURZY LEGAL
  {
    path: "/zasady_kurzy",
    element: <ZasadySoukromiKurzy />,
    handle: darkNavbar
  },
  {
    path: "/podminky_kurzy",
    element: <ObchodniPodminkyKurzy />,
    handle: darkNavbar
  },
  {
    path: "/dokumenty",
    element: <Dokumenty />,
    handle: darkNavbar
  },
  {
    path: "/cookies",
    element: <Cookies />,
    handle: darkNavbar
  },
  // ADMIN
  {
    path: "/login",
    element: <AdminLogin />,
    handle: { hideNavbar: true },
  },
  {
    path: "/preview",
    element: <PreviewPage />,
    handle: { hideNavbar: true },
  },
  // KURZY
  {
    path: "/kurzy",
    element: <CoursesMain />,
    handle: darkNavbar
  },
  {
    path: "/kurzy_rezervace",
    element: <CoursesForm />,
    handle: darkNavbar
  },
];
export default baseRoutes;
